// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1i-q";
export var animationRelative = "_1i-p";
export var backdropBlur = "_1i-0";
export var detailLabelCell = "_1i-12";
export var detailTable = "_1i-11";
export var detailValueCell = "_1i-13";
export var docIconBox = "_1i-1d";
export var docIconBoxMd = "_1i-1f";
export var docIconBoxSm = "_1i-1e";
export var docTypeRow = "_1i-16";
export var docTypeRowInner = "_1i-17";
export var dropdownMatchDatePicker = "_1i-3";
export var evidenceCardContent = "_1i-1c";
export var fileUploadSpin = "_1i-j";
export var gorgiasOpenButton = "_1i-15 _1i-d";
export var gorgiasTicketCard = "_1i-14";
export var heroModalFooterButton = "_1i-18";
export var hiddenContainer = "_1i-o";
export var iconPrimary = "_1i-1g";
export var iconSecondary = "_1i-1h";
export var iconTertiary = "_1i-1i";
export var integrationCard = "_1i-1";
export var integrationLogoBox = "_1i-2";
export var mainColumnSticky = "_1i-1b";
export var maxWidthContainer = "_1i-19";
export var modalContentBody = "_1i-a";
export var modalHeaderImage = "_1i-5";
export var modalImageLabel = "_1i-7";
export var modalImageOverlay = "_1i-6";
export var modalImageSubtitle = "_1i-9";
export var modalImageTitle = "_1i-8";
export var modalImageWrapper = "_1i-4";
export var modalStickyFooter = "_1i-b";
export var removeButton = "_1i-e";
export var sidebarColumn = "_1i-1a";
export var spinner = "_1i-i";
export var timelineLine = "_1i-y";
export var timelineLineBlack = "_1i-10 _1i-y";
export var timelineLineGray = "_1i-z _1i-y";
export var timelineLineHeight = "_1i-x";
export var tlDotActivate = "_1i-u";
export var tlDotActivateAnim = "_1i-t";
export var tlDotHide = "_1i-s";
export var tlDotHideAnim = "_1i-r";
export var tlLineActivate = "_1i-w";
export var tlLineActivateAnim = "_1i-v";
export var uploadHint = "_1i-n";
export var uploadIconBox = "_1i-k";
export var uploadLabel = "_1i-m";
export var uploadText = "_1i-l";
export var uploadZone = "_1i-f";
export var uploadZoneCursorDefault = "_1i-h";
export var uploadZoneCursorPointer = "_1i-g";
export var uploadedFileRow = "_1i-c";
export var viewButton = "_1i-d";